export function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1)
}

export function unaccent(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
